var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","ma-0":"","pa-0":"","fill-height":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('Toolbar',{attrs:{"tooltipMessage":"Hier können Sie Kunden verwalten","toolbarTitle":"Kunden"}})],1),_c('v-flex',{attrs:{"grow":""}},[_c('CustomerManager',{attrs:{"customer":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }